import { createContext, useContext, useState } from 'react';

interface MultiPageProviderProps {
    steps: JSX.Element[];
}

interface MultiPageContextProps {
    steps: JSX.Element[];
    currentStepIndex: number;
    next: () => void;
    back: () => void;
    isFirstStep: boolean;
    isLastStep: boolean;
}

const noProviderError = () => {
    console.error('No StepModalWizardProvider present');
};

const MultiPageWizardContext = createContext<MultiPageContextProps>({
    steps: [],
    currentStepIndex: 0,
    next: noProviderError,
    back: noProviderError,
    isFirstStep: true,
    isLastStep: false,
});

export const StepsModalWizardContextProvider: React.FC<MultiPageProviderProps> = (props) => {
    const { steps, children } = props;
    const [currentStepIndex, setCurrentStepIndex] = useState<number>(0);

    const next = () => {
        setCurrentStepIndex((i: number) => {
            if (i >= steps.length - 1) {
                return i;
            }
            return i + 1;
        });
    };

    const back = () => {
        setCurrentStepIndex((i: number) => {
            if (i <= 0) {
                return 0;
            }
            return i - 1;
        });
    };

    const contextValue = {
        steps,
        currentStepIndex,
        next,
        back,
        isFirstStep: currentStepIndex === 0,
        isLastStep: currentStepIndex === steps.length - 1,
    };

    return <MultiPageWizardContext.Provider value={contextValue}>{children}</MultiPageWizardContext.Provider>;
};

export const useMultiPageWizard = () => useContext<MultiPageContextProps>(MultiPageWizardContext);
